import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

/**
 * Blocks in-app navigation and warns on refresh/close while `when` is true.
 * `onBlocked` is called whenever an in-app navigation is prevented.
 * Returns `release`, to lift the guard right before an intended navigation.
 */
const useLeaveGuard = ({ when, onBlocked }) => {
  const history = useHistory();
  const onBlockedRef = useRef(onBlocked);
  onBlockedRef.current = onBlocked;
  const releaseRef = useRef(() => {});

  useEffect(() => {
    if (!when) {
      return;
    }

    let released = false;
    const unblock = history.block(() => {
      onBlockedRef.current?.();
      return false;
    });

    const handleBeforeUnload = (e) => {
      // logout and session expiry clear the token before redirecting; let those through
      if (!localStorage.getItem("accessToken")) {
        return;
      }
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    const release = () => {
      if (released) {
        return;
      }
      released = true;
      unblock();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
    releaseRef.current = release;

    return release;
  }, [when, history]);

  return () => releaseRef.current();
};

export default useLeaveGuard;
